import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material'

export const SpreadBoardCardContainer = styled.div`
  margin: 30px 0;
`

export const SpreadBoardMultiPartContainer = styled.div`
  display: flex;
  overflow: auto;
  position: relative;
  width: 100%;

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ${(props) => !props?.isMobile && 'padding: 40px 0'};
  @media (min-width: 768px) {
    ${(props) => !props?.isMobile && 'padding: 60px 0'};
  }
  @media (min-width: 1024px) {
    ${(props) => !props?.isMobile && 'padding: 80px 0'};
  }
  @media (max-height: 880px) {
    ${(props) => !props?.isMobile && 'padding: 60px 0'};
  }
`

export const SpreadBoardParentItemBackground = styled.div`
  background: url(${(props) => props?.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
`

export const SpreadBoardContentContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props?.isMobile ? 'column' : 'row')};
  width: 100%;
  z-index: 2;
  overflow: hidden;
`

export const SpreadBoardShowAllHeadingContainerForPositioning = muiStyled('div')(
  ({ theme, isHovered }) => `
width: 100%;
position: absolute;
top: 30px;
opacity: ${isHovered ? 1 : 0};
transition: all 0.5s ease-in-out 1.3s;
top: 10px;
`,
)

export const SpreadBoardDetailsLandScapeContainer = styled.div`
  background: linear-gradient(180deg, #000000 -3.11%, rgba(111, 111, 111, 0) 100%);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 1s ease 1s;
  transform: ${(props) => (props?.isHovered ? 'translateY(-100%)' : 'translateY(0)')};
`

export const SpreadBoardDetailsPortraitContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(#000000 -3.11%, rgba(111, 111, 111, 0) 100%);
  padding: 15px 0;
  @media (min-width: 768px) {
    padding: 30px 0;
  }
  @media (min-width: 1024px) {
    padding: 45px 0;
  }
`

export const SpreadBoardDetailsTitle = styled.div`
  color: #fff;

  text-align: ${(props) => (props?.isMobile ? 'center' : 'left')};
  max-width: ${(props) => (props?.isMobile ? '80%' : '465px')};

  padding-left: ${(props) => (props?.isMobile ? '0px' : '14px')};
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;

  @media (min-width: 768px) {
    font-size: 45px;
    font-weight: 600;
    line-height: 55px;
    padding-left: ${(props) => (props?.isMobile ? '0px' : '28px')};
  }
  @media (min-width: 1024px) {
    font-size: 70px;
    font-weight: 600;
    line-height: 81px;
    padding-left: ${(props) => (props?.isMobile ? '0px' : '42px')};
  }
  @media (max-height: 880px) {
    font-weight: 600;
    padding-left: ${(props) => (props?.isMobile ? '0px' : '28px')};
    font-size: 30px;
    line-height: 35px;
  }
`

export const SpreadBoardDetailsSubtitle = styled.div`
  color: #fff;
  margin: 16px 0 0 0;
  text-align: ${(props) => (props?.isMobile ? 'center' : 'left')};
  max-width: ${(props) => (props?.isMobile ? '80%' : '40%')};

  padding-left: ${(props) => (props?.isMobile ? '0px' : '14px')};
  font-weight: 400;
  line-height: 15px;
  font-size: 14px;

  @media (min-width: 768px) {
    font-weight: 400;
    line-height: 26px;
    font-size: 20px;
    padding-left: ${(props) => (props?.isMobile ? '0px' : '28px')};
  }
  @media (min-width: 1024px) {
    font-weight: 400;
    line-height: 30px;
    font-size: 24px;
    padding-left: ${(props) => (props?.isMobile ? '0px' : '42px')};
  }
  @media (max-height: 880px) {
    font-weight: 400;
    line-height: 15px;
    font-size: 14px;
    padding-left: ${(props) => (props?.isMobile ? '0px' : '28px')};
  }
`

export const SpreadBoardDetailsButton = styled.div`
  color: #fff;
  margin: 16px 0 0 0;
  margin-left: ${(props) => (props?.isMobile ? '0px' : '14px')};
  font-weight: 400;
  line-height: 20px;
  font-size: 16px;
  border: 3px solid #fff;
  border-radius: 21px;
  cursor: pointer;
  max-width: 280px;
  gap: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.1em 0.1em 0.1em;
  @media (min-width: 768px) {
    font-weight: 400;
    line-height: 26px;
    font-size: 20px;
    margin-left: ${(props) => (props?.isMobile ? '0px' : '28px')};
    padding: 0.3em 0.3em 0.3em;
  }
  @media (min-width: 1024px) {
    font-weight: 400;
    line-height: 30px;
    font-size: 24px;
    margin-left: ${(props) => (props?.isMobile ? '0px' : '42px')};
    padding: 0.5em 0.5em 0.5em;
  }
  @media (max-height: 880px) {
    font-weight: 400;
    line-height: 26px;
    font-size: 20px;
    margin-left: ${(props) => (props?.isMobile ? '0px' : '28px')};
    max-width: 260px;
  }
`

export const SpreadBoardSecondaryItemsContainer = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  margin: auto auto;
  width: 100%;
  overflow-x: auto;
  transition: transform 1s ease 1s;
  transform: ${(props) => (props?.isHovered ? 'translateX(0)' : 'translateX(70%)')};
  ${(props) => props?.isMobile && `transform: translateX(0);`};
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  padding: 45px 21px;
  gap: 25px;

  @media (min-width: 768px) {
    padding: 55px 31px;
    gap: 35px;
    transform: ${(props) => (props?.isHovered ? 'translateX(0)' : 'translateX(55%)')};
    ${(props) => props?.isMobile && `transform: translateX(0);`};
  }
  @media (min-width: 1024px) {
    padding: 65px 41px;
    gap: 45px;
    transform: ${(props) => (props?.isHovered ? 'translateX(0)' : 'translateX(40%)')};
    ${(props) => props?.isMobile && `transform: translateX(0);`};
  }
  @media (max-height: 880px) {
    padding: 55px 31px;
    gap: 35px;
    transform: ${(props) => (props?.isHovered ? 'translateX(0)' : 'translateX(55%)')};
    ${(props) => props?.isMobile && `transform: translateX(0);`};
  }
`

export const SpreadSecondaryItemBackground = styled.img`
  width: 100%;
  height: 100%;
  transition: all 0.5s ease-in-out;
  z-index: 1;
  position: absolute;
  top: 0;
  object-fit: cover;
`

export const SpreadBoardBackFilterBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: linear-gradient(0deg, #000000 -3.11%, rgba(111, 111, 111, 0) 100%);
  z-index: 1;
`

export const SpreadBoardSecondaryItemDetails = styled.div`
  width: 100%;
  height: 100%;
  transition: all 0.5s ease-in-out;
  z-index: 2;
  padding: 13px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 0;
`

export const SpreadBoardSecondarySingleItemContainer = styled.div`
  background: url(${(props) => props?.imgSrc});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  overflow: auto;
  ${({ nopointer }) => !nopointer && 'cursor: pointer;'}
  transition: all 0.3s ease-in-out 1s;
  position: relative;
  box-shadow: 10px 11px 12px 0px rgba(0, 0, 0, 0.47);
  border-radius: 11px;
  flex: ${(props) =>
    props?.preselected && !props?.isHovered && !props?.isMobile ? '0 0 162px' : '0 0 125px'};
  height: ${(props) =>
    props?.preselected && !props?.isHovered && !props?.isMobile ? '240px' : '185px'};
  overflow: hidden;
  @media (min-width: 768px) {
    flex: ${(props) =>
      props?.preselected && !props?.isHovered && !props?.isMobile ? '0 0 250px' : '0 0 193px'};
    height: ${(props) =>
      props?.preselected && !props?.isHovered && !props?.isMobile ? '370px' : '285px'};
    border-radius: 16px;
  }
  @media (min-width: 1024px) {
    flex: ${(props) =>
      props?.preselected && !props?.isHovered && !props?.isMobile ? '0 0 339px' : '0 0 261px'};
    height: ${(props) =>
      props?.preselected && !props?.isHovered && !props?.isMobile ? '500px' : '385px'};
    border-radius: 22px;
  }
  @media (max-height: 880px) {
    flex: ${(props) =>
      props?.preselected && !props?.isHovered && !props?.isMobile ? '0 0 250px' : '0 0 193px'};
    height: ${(props) =>
      props?.preselected && !props?.isHovered && !props?.isMobile ? '370px' : '285px'};
    border-radius: 16px;
  }
  &:hover {
    ${SpreadSecondaryItemBackground} {
      transform: scale(1.05);
    }
  }
`

export const SpreadBoardHeading = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  color: #fff;
  @media (min-width: 768px) {
    font-size: 25px;
    font-weight: 600;
    line-height: 29px;
  }
  @media (min-width: 1024px) {
    font-size: 30px;
    font-weight: 600;
    line-height: 38px;
  }
  @media (max-height: 880px) {
    font-size: 25px;
    font-weight: 600;
    line-height: 29px;
  }
`

export const SpreadBoardSubHeading = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  min-height: 30px;
  color: #fff;
  @media (min-width: 768px) {
    left: 21px;
    font-size: 17px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    min-height: 35px;
  }
  @media (min-width: 1024px) {
    left: 21px;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
    min-height: 60px;
  }
`

export const SpreadBoardTertiaryHeading = styled.div`
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 5px;
  @media (min-width: 768px) {
    gap: 10px;
    left: 21px;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
  }
  @media (min-width: 1024px) {
    left: 21px;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
  }
`

export const SpreadBoardLockedItemOverlay = styled.div`
  height: 100%;
  width: 100%;
  backdrop-filter: blur(10px);
  position: absolute;
  top: 0px;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`
export const LockedIcon = styled.div`
  font-size: 24px;
  @media (min-width: 768px) {
    font-size: 35px;
  }
`

export const SpreadBoardActualDetailsContainer = muiStyled('div')(
  ({ theme }) => `
display: flex;
flex-direction: column;
justify-content: flex-end;
`,
)

export const SpreadBoardBoxDetailsContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: 100%;
`,
)
export const SpreadBoardBoxBorder = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
  border-radius: 200px;
  width: 64px;
  aspect-ratio: 1;
  gap: 0px;
  @media (min-width: 768px) {
    padding: 10px;
    width: 135px;
    padding: 25px;
  }
`,
)
